module.exports = "/wwwroot/img/iframe_block.png?ver=e7ffd197";